import type { StoreFrontDto } from '@b-stock/listing-api-client'

import getStorefrontUrl from './getStorefrontUrl'

export default function useStorefrontUrl(
  storefront: StoreFrontDto | null | undefined
) {
  return getStorefrontUrl(storefront)
}
